import React from "react";

const ClockOut = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#4E525F"
            d="M19.454 32.333C27.489 32.333 34 25.767 34 17.667 34 9.567 27.488 3 19.454 3a14.425 14.425 0 0 0-6.506 1.546 14.553 14.553 0 0 0-5.13 4.32h3.942a11.594 11.594 0 0 1 5.966-2.802 11.55 11.55 0 0 1 6.518.91 11.664 11.664 0 0 1 4.988 4.33 11.804 11.804 0 0 1 1.86 6.364c0 2.258-.646 4.468-1.861 6.365a11.664 11.664 0 0 1-4.988 4.329 11.55 11.55 0 0 1-6.52.908 11.595 11.595 0 0 1-5.964-2.803H7.816a14.553 14.553 0 0 0 5.13 4.32 14.425 14.425 0 0 0 6.508 1.546Zm-10.181-8.8v-4.4h11.636V16.2H9.273v-4.4L2 17.667l7.273 5.866Z"
        />
    </svg>
);

export default ClockOut;
